import { ref } from "vue";

const getPages = () => {
    const pages = ref(null);
    const load = (pagesFromComponent) => {
        if (!pagesFromComponent) {
            pages.value = [];
        } else {
            pages.value = pagesFromComponent.meta.links.filter((link) => !Number.isNaN(parseInt(link.label, 10)));
        }
    };
    return { pages, load };
};

export default getPages;
